export const handlePrint = async (
  file
) => {
  const DPI = 300;

  const canvasWidth = 4 * DPI;
  const canvasHeight = 6 * DPI;

  const photoSize = 2 * DPI;

  const canvas =
    document.createElement("canvas");

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  const ctx =
    canvas.getContext("2d");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(
    0,
    0,
    canvasWidth,
    canvasHeight
  );

  const img = new Image();

  img.crossOrigin = "anonymous";

  const imageSrc =
    file instanceof Blob
      ? URL.createObjectURL(file)
      : file;

  img.onload = () => {
    let sourceX;
    let sourceY;
    let sourceWidth;
    let sourceHeight;

    const imgAspect =
      img.width / img.height;

    if (imgAspect > 1) {
      sourceHeight = img.height;
      sourceWidth = img.height;

      sourceX =
        (img.width - img.height) / 2;

      sourceY = 0;
    } else {
      sourceWidth = img.width;
      sourceHeight = img.width;

      sourceX = 0;

      sourceY =
        (img.height - img.width) / 2;
    }

    const xPos =
      (canvasWidth - photoSize) / 2;

    const yPos1 = 200;
    const yPos2 = 1000;

    ctx.drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      xPos,
      yPos1,
      photoSize,
      photoSize
    );

    ctx.drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      xPos,
      yPos2,
      photoSize,
      photoSize
    );

    canvas.toBlob(
      (printBlob) => {
        const printUrl =
          URL.createObjectURL(printBlob);

        const iframe =
          document.createElement("iframe");

        Object.assign(
          iframe.style,
          {
            position: "fixed",
            right: "0",
            bottom: "0",
            width: "0",
            height: "0",
            border: "0",
          }
        );

        document.body.appendChild(
          iframe
        );

        const doc =
          iframe.contentWindow.document;

        doc.open();

        doc.write(`
          <html>
            <head>
              <style>
                @page {
                  size: 4in 6in;
                  margin: 0;
                }

                body {
                  margin: 0;
                  padding: 0;
                }

                img {
                  width: 4in;
                  height: 6in;
                  display: block;
                }
              </style>
            </head>

            <body>
              <img src="${printUrl}" />
            </body>
          </html>
        `);

        doc.close();

        const printImage =
          doc.querySelector("img");

        printImage.onload = () => {
          iframe.contentWindow.focus();

          iframe.contentWindow.print();

          setTimeout(() => {
            document.body.removeChild(
              iframe
            );

            URL.revokeObjectURL(
              printUrl
            );

            if (
              file instanceof Blob
            ) {
              URL.revokeObjectURL(
                imageSrc
              );
            }
          }, 1000);
        };
      },
      "image/png",
      1
    );
  };

  img.src = imageSrc;
};